import { PropsWithChildren, createContext } from 'react';
import { useParams } from 'react-router';
import { getHotelById } from '../apis/hotelApis';
import { Alert } from 'react-bootstrap';
import { language } from '../common/constants';
import { Loader } from '../controls/Loader';
import { IHotelInfo } from '../types/hotelTypes';
import { useQuery } from '@tanstack/react-query';

export interface IHotelContext {
  hotel: IHotelInfo;
  source?: string;
}

export const HotelContext = createContext<IHotelContext>(null);

interface IHotelContextProps {
  source?: string;
}

export const HotelContextProvider = ({ children, source }: PropsWithChildren<IHotelContextProps>) => {
  const { hotelId } = useParams();
  const { data: hotel, error: hotelError } = useQuery({
    queryKey: [`/api/hotels/${hotelId}`],
    queryFn: () => getHotelById(hotelId),
  });

  if (hotelError) {
    return <Alert variant="danger">{language.GENERIC_ERROR}</Alert>;
  }

  if (!hotel) {
    return <Loader />;
  }

  return (
    <HotelContext.Provider
      value={{
        hotel,
        source,
      }}>
      {children}
    </HotelContext.Provider>
  );
};
